module.exports = __webpack_public_path__ + "img/wastebox_yellow.min.ef46120b.png";